/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_PhoneInputs */

const vi_customer_phone = /** @type {(inputs: Customer_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điện thoại`)
};

/**

* @param {Customer_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_phone = /** @type {((inputs?: Customer_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_phone(inputs)
});